// extracted by mini-css-extract-plugin
module.exports = {"empty-state-container":"EmailDigest-module__empty-state-container__2Waf1"};